import { render, staticRenderFns } from "./ObiIcon.vue?vue&type=template&id=68c19836&scoped=true&"
import script from "./ObiIcon.vue?vue&type=script&lang=js&"
export * from "./ObiIcon.vue?vue&type=script&lang=js&"
import style0 from "./ObiIcon.vue?vue&type=style&index=0&id=68c19836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c19836",
  null
  
)

export default component.exports